import script from "./HrListGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./HrListGroup.vue?vue&type=script&setup=true&lang=js"

import "./HrListGroup.vue?vue&type=style&index=0&id=2fe3dc9a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fe3dc9a"]])

export default __exports__